import React, { useEffect, useRef, useState } from "react";
import useMeasure from "react-use-measure";
import { classNames } from "@greeter-venue/utility";

import css from "./Slip.module.scss";
import slip from "./slip.svg";

type Position = {
  x: number;
  y: number;
};

function C({ c1, c2, p }: { c1: Position; c2: Position; p: Position }) {
  return `C${c1.x},${c1.y} ${c2.x},${c2.y} ${p.x},${p.y}`;
}

function convertRemToPixels(rem: number) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export type SlipProps = {
  debug?: boolean;
  className?: string;
}

export const Slip: React.FC<SlipProps> = ({ className, debug, ...props }) => {
  const [ref, { width, height }] = useMeasure();

  const [bevelHeight] = useState(convertRemToPixels(4));
  const [path, setPath] = useState("");

  useEffect(() => {
    setPath(
      [
        `M 0,0 ${width},0 ${width},${height - bevelHeight}`,
        `C ${width},${height} 0,${height} 0,${height - bevelHeight}`,
      ].join(" ")
    );
  }, [width, height, bevelHeight]);

  return (
    <>
      <div
        {...props}
        ref={ref}
        style={{
          clipPath: `path("${path}")`,
          paddingBottom: `${bevelHeight}px`,
        }}
        {...classNames(className, css.Slip)}
      ></div>
      {debug && (
        <svg height="500">
          <path id="rect31" d={`${path}`} />
        </svg>
      )}
    </>
  );
};

